import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './par-language-communication.reducer';
import { IParLanguageCommunication } from 'app/shared/model/par-language-communication.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParLanguageCommunication = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const parLanguageCommunicationList = useAppSelector(state => state.parLanguageCommunication.entities);
  const loading = useAppSelector(state => state.parLanguageCommunication.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="par-language-communication-heading" data-cy="ParLanguageCommunicationHeading">
        <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.home.title">Par Language Communications</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.home.createLabel">
              Create new Par Language Communication
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {parLanguageCommunicationList && parLanguageCommunicationList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {parLanguageCommunicationList.map((parLanguageCommunication, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${parLanguageCommunication.id}`} color="link" size="sm">
                      {parLanguageCommunication.id}
                    </Button>
                  </td>
                  <td>{parLanguageCommunication.code}</td>
                  <td>{parLanguageCommunication.name}</td>
                  <td>{parLanguageCommunication.nameAr}</td>
                  <td>{parLanguageCommunication.nameEn}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${parLanguageCommunication.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${parLanguageCommunication.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${parLanguageCommunication.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${parLanguageCommunication.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.home.notFound">
                No Par Language Communications found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ParLanguageCommunication;
